<template>
  <atlas-link
    v-if="link"
    class="atlas-button secondary"
    :to="link"
    external
  >
    <template #default>
      <atlas-icon name="common/epaper" />
      <span>Eavis</span>
    </template>
  </atlas-link>
</template>
<script setup lang="ts">

import { AtlasLink, AtlasIcon } from '@nhst/ui';

const link = computedAsync(async () => {
  return await useArticle().getPDFButtonLink();
});
</script>

<style lang="scss" scoped>
.atlas-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}
</style>
